let arr = [
  {
    url: "/productManagement",
    resourceId: "Layout",
    redirect: "/productManagement/brand",
    meta: { title: "产品管理", icon: "slack" },
    childEntity: [
      {
        url: "brand",
        resourceId: "/productManagement/brandManage/brand",
        meta: { title: "品牌管理", icon: "arrow-right" }
      },
      {
        url: "company",
        resourceId: "/productManagement/companyManage/company",
        meta: { title: "公司管理", icon: "arrow-right" }
      },
      {
        url: "protocol",
        resourceId: "/productManagement/protocolManage/protocol",
        meta: { title: "协议管理", icon: "arrow-right" }
      },
      {
        url: "product",
        resourceId: "/productManagement/productManage/product",
        meta: { title: "产品管理", icon: "arrow-right" }
      },
      {
        url: "vehicle",
        resourceId: "/productManagement/vehicleManage/vehicle",
        meta: { title: "车险产品管理", icon: "arrow-right" }
      },
      {
        url: "category",
        resourceId: "/productManagement/productCategory/category",
        meta: { title: "产品分类管理", icon: "arrow-right" }
      },
      {
        url: "activity",
        resourceId: "/productManagement/activityManage/activity",
        meta: { title: "活动推广管理", icon: "arrow-right" }
      },
      {
        url: "productSort",
        resourceId: "/productManagement/productSortManage/productSort",
        meta: { title: "产品排序值管理", icon: "arrow-right" }
      },
      {
        url: "rights",
        resourceId: "/productManagement/rightsManage/rights",
        meta: { title: "权益管理", icon: "arrow-right" }
      }
    ]
  },

  {
    url: "/coreManagement",
    resourceId: "Layout",
    redirect: "/coreManagement/insurance",
    meta: { title: "核心数据管理", icon: "archive-fill" },
    childEntity: [
      {
        url: "insurance",
        resourceId: "/coreManagement/insuranceManage/insurance",
        meta: { title: "险种分类管理", icon: "arrow-right" }
      },
      {
        url: "regional",
        resourceId: "/coreManagement/regionalManage/regional",
        meta: { title: "区域管理", icon: "arrow-right" }
      },
      {
        url: "dictionary",
        resourceId: "/coreManagement/dictionaryManage/dictionary",
        meta: { title: "字典管理", icon: "arrow-right" }
      }
    ]
  },

  {
    url: "/policyManagement",
    resourceId: "Layout",
    redirect: "/policyManagement/carPolicy",
    meta: { title: "保单管理", icon: "stickies-fill" },
    childEntity: [
      {
        url: "carPolicy",
        resourceId: "/policyManagement/carManagement/carPolicy",
        meta: { title: "车险保单管理", icon: "arrow-right" }
      },
      {
        url: "netOrder",
        resourceId: "/policyManagement/netPolicyManagement/netOrder",
        meta: { title: "网销订单管理", icon: "arrow-right" }
      },
      {
        url: "netPolicy",
        resourceId: "/policyManagement/netPolicyManagement/netPolicy",
        meta: { title: "网销保单管理", icon: "arrow-right" }
      },
      {
        url: "byGenPolicy",
        resourceId: "/policyManagement/byGenManagement/byGenPolicy",
        meta: { title: "经代保单管理", icon: "arrow-right" }
      },
      {
        url: "surrenderPolicy",
        resourceId: "/policyManagement/surrenderManagement/surrenderPolicy",
        meta: { title: "退保管理", icon: "arrow-right" }
      },
      {
        url: "bookVipPayInfo",
        resourceId: "/policyManagement/bookManagement/bookVipPayInfo",
        meta: { title: "好书精华管理", icon: "arrow-right" }
      },
      {
        url: "bookVipSettle",
        resourceId: "/policyManagement/bookManagement/bookVipSettle",
        meta: { title: "好书精华公司结算", icon: "arrow-right" }
      }
    ]
  },

  {
    url: "/userManagement",
    resourceId: "Layout",
    meta: {
      title: "用户管理",
      icon: "people-fill"
    },
    childEntity: [
      {
        url: "team",
        resourceId: "/userManagement/teamManage/team.vue",
        meta: {
          title: "团队管理",
          icon: "arrow-right",
          auths: [
            "team-add",
            "team-edit",
            "team-delete",
            "team-close-settle",
            "team-manage",
            "team-member-edit"
          ]
        }
      },
      {
        url: "store",
        resourceId: "/userManagement/storeManage/store",
        meta: {
          title: "连锁店管理",
          icon: "arrow-right",
          auths: ["", "", ""]
        }
      },
      {
        url: "partner",
        resourceId: "/userManagement/partnerManage/partner",
        meta: {
          title: "合伙人管理",
          icon: "arrow-right"
        }
      },
      {
        url: "member",
        resourceId: "/userManagement/memberManage/member",
        meta: {
          title: "会员管理",
          icon: "arrow-right"
        }
      },
      {
        url: "customer",
        resourceId: "/userManagement/customerManage/customer",
        meta: {
          title: "客户管理",
          icon: "arrow-right"
        }
      },
      {
        url: "agentApplication",
        resourceId: "/userManagement/agentApplication/index",
        meta: {
          title: "代理人审核",
          icon: "arrow-right"
        }
      },
      {
        url: "agent",
        resourceId: "/userManagement/agentManage/agent",
        meta: {
          title: "代理人管理",
          icon: "arrow-right"
        }
      }
    ]
  },
  {
    url: "/systemConfigManagement",
    resourceId: "Layout",
    redirect: "/systemConfigManagement/systemAuthorityManagement",
    meta: { title: "系统配置", icon: "gear-fill" },
    childEntity: [
      {
        url: "carPolicy",
        resourceId:
          "/systemConfigManagement/systemAuthorityManagement/authorityManagement",
        meta: { title: "会员权限配置", icon: "arrow-right" }
      },
      {
        url: "systemConfig",
        resourceId: "/systemConfigManagement/systemConfig/systemConfig",
        meta: { title: "系统配置项", icon: "arrow-right" }
      },
      {
        url: "allocationPlan",
        resourceId: "/productManagement/rightsManage/allocationPlan",
        meta: { title: "产品计划配置", icon: "arrow-right" }
      },
      {
        url: "role",
        resourceId: "/systemConfigManagement/roleManage/role",
        meta: { title: "角色管理", icon: "arrow-right" }
      }
    ]
  },
  {
    url: "/businessAccountManagement",
    resourceId: "Layout",
    meta: { title: "业务核账管理", icon: "border-style" },
    childEntity: [
      {
        url: "agentAccount",
        resourceId:
          "/businessAccountManagement/agentAccountManage/agentAccount",
        meta: { title: "代理人核账管理", icon: "arrow-right" }
      },
      {
        url: "partnerAccount",
        resourceId:
          "/businessAccountManagement/partnerAccountManage/partnerAccount",
        meta: { title: "合伙人核账管理", icon: "arrow-right" }
      },
      {
        url: "chainStoreAccount",
        resourceId:
          "/businessAccountManagement/chainStoreAccountManage/chainStoreAccount",
        meta: { title: "连锁店核账管理", icon: "arrow-right" }
      },
      {
        url: "companyAccount",
        resourceId:
          "/businessAccountManagement/companyAccountManage/companyAccount",
        meta: { title: "公司核账管理", icon: "arrow-right" }
      },
      {
        url: "userExtendAccount",
        resourceId:
          "/businessAccountManagement/userAccountManage/userExtendAccount",
        meta: { title: "用户推广费核账", icon: "arrow-right" }
      }
    ]
  },
  {
    url: "/withDrawalManagement",
    resourceId: "Layout",
    redirect: "/withDrawalManagement/personalWDAuditManage",
    meta: { title: "提现审核管理", icon: "joystick" },
    childEntity: [
      {
        url: "companyWDAudit",
        resourceId: "/withDrawalManagement/companyWDAuditManage/companyWDAudit",
        meta: { title: "公司提现审核管理", icon: "arrow-right" }
      },
      {
        url: "personalWDAudit",
        resourceId:
          "/withDrawalManagement/personalWDAuditManage/personalWDAudit",
        meta: { title: "个人提现审核管理", icon: "arrow-right" }
      }
    ]
  },
  {
    url: "/financialAccountManagement",
    resourceId: "Layout",
    meta: { title: "财务核账管理", icon: "joystick" },
    childEntity: [
      {
        url: "companyTicket",
        resourceId:
          "/financialAccountManagement/companyTicketManage/companyTicket",
        meta: { title: "公司出票管理", icon: "arrow-right" }
      }
    ]
  }
];
import Layout from "@/layout"; //Layout 是架构组件，不在后台返回，在文件里单独引入
import MenuMain from "@/layout/MenuMain"; //Layout 是架构组件，不在后台返回，在文件里单独引入
import router from "./index.js";
import store from "../store/index.js";
var Letter = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];
function filterAsyncRouter(asyncRouterMap) {
  //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter((route, i) => {
    route.path = route.url ? route.url : "menu" + Letter[i];

    if (route.childEntity && route.childEntity.length) {
      route.meta = {
        title: route.name,
        icon: route.resourceId ? route.menuIco : "blockquote-right"
      };
    } else {
      route.meta = { title: route.name, icon: "arrow-right", code: route.code };
    }

    if (!route.component) {
      if (!route.resourceId) {
        //子菜单后台不存resourceId
        route.component = MenuMain;
      } else if (route.resourceId === "Layout") {
        //Layout组件特殊处理
        route.component = Layout;
      } else {
        // route.component =   require('@/components' + route.resourceId)
        let component = resolve =>
          require.ensure([], () =>
            resolve(require("@/components" + route.resourceId))
          );
        route.component = component;
      }
    }
    if (route.childEntity && route.childEntity.length) {
      route.children = filterAsyncRouter(route.childEntity);
    }
    return true;
  });
  return accessedRouters;
}

function routerGo(to, next, list) {
  // console.log(JSON.stringify(list))
  let getRouter = filterAsyncRouter(list); //过滤路由
  // console.log(JSON.stringify(getRouter))
  router.addRoutes(getRouter); //动态添加路由
  router.addRoutes([
    {
      path: "*",
      component: () => import("@/components/common/404"),
      redirect: "/404",
      hidden: true
    }
  ]); // 404 page must be placed at the end !!!
  store.commit("updateRoutes", { routes: getRouter }); //将路由数据传递，做侧边栏菜单渲染工作
  next({
    ...to,
    replace: true
  });
}

function getObjArr(name) {
  //localStorage 获取数组对象的方法
  return window.localStorage.getItem(name) &&
    window.localStorage.getItem(name).constructor == Object
    ? JSON.parse(window.localStorage.getItem(name))
    : null;
}

export { routerGo, getObjArr, arr };



// WEBPACK FOOTER //
// ./src/router/import_router.js